import { CustomTableChunk } from '../types/add_commerce.types';
import instance from './axios';

export type BusinessSectorTableResponse = {
  type: string;
  standard: { master: CustomTableChunk[]; visa: CustomTableChunk[] };
  exceeds: { master: CustomTableChunk[]; visa: CustomTableChunk[] };
};

const getBusinessSectorTable = async (businessSector: string): Promise<BusinessSectorTableResponse> => {
  const response = await instance.get<{ data: BusinessSectorTableResponse }>('/business-sector/table', {
    headers: { businessSector },
  });

  return response.data.data;
};

export const businessSectorService = { getBusinessSectorTable };
